import React, { useState, useEffect } from 'react';

const WhyUs = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const advantages = [
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
            ),
            title: "Anında Ulaşım",
            description: "Davetiyenizi hazırladıktan sonra anında misafirlerinize WhatsApp, SMS veya e-posta ile gönderin.",
            benefit: "Dakikalar içinde"
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                </svg>
            ),
            title: "Maliyet Avantajı",
            description: "Geleneksel davetiye maliyetinin %90'ına kadar tasarruf edin. Baskı, kargo ve zarf masrafları yok.",
            benefit: "%90 tasarruf"
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
            ),
            title: "Çevre Dostu",
            description: "Kağıt kullanımını sıfırlayarak doğayı koruyun. Her dijital davetiye bir ağaç kurtarır.",
            benefit: "0 kağıt"
        },

        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
            ),
            title: "İnteraktif Özellikler",
            description: "Fotoğraf galerisi, konum haritası ve RSVP sistemi ile zengin deneyim.",
            benefit: "Sınırsız özellik"
        },
        {
            icon: (
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
            ),
            title: "Kolay Güncelleme",
            description: "Tarih, saat veya mekân değişikliği mi var? Tek tıkla bize haber verin ve güncelleyelim.",
            benefit: "Tek tık ile güncelleme"
        }
    ];

    // Otomatik slider ilerlemesi - advantages tanımlandıktan sonra
    useEffect(() => {
        const slideInterval = setInterval(() => {
            // Bir sonraki slide'a geç
            setCurrentSlide(prevSlide => {
                const maxSlides = Math.ceil(advantages.length / 2);
                return prevSlide < maxSlides - 1 ? prevSlide + 1 : 0;
            });
        }, 4000); // 4 saniyede bir ilerle

        return () => clearInterval(slideInterval);
    }, [advantages.length]);

    const comparisons = [
        { feature: "Hazırlık Süresi", traditional: "Uzun", digital: " Kısa", winner: "digital" },
        { feature: "Maliyet", traditional: "Pahalı", digital: "Uygun", winner: "digital" },
        { feature: "Ulaşım Süresi", traditional: "3-7 Gün", digital: "Anında", winner: "digital" },
        { feature: "Çevre Etkisi", traditional: "Yüksek", digital: "Sıfır", winner: "digital" },
        { feature: "Güncelleme", traditional: "İmkansız", digital: "Kolay", winner: "digital" },
    ];

    return (
        <>
            {/* Nasıl Çalışır Bölümü */}
            <section id="nasil-calisir" className="relative py-20 lg:py-28 bg-gradient-to-b from-white via-primary-25 to-primary-50 overflow-hidden">
                {/* Arka plan dekoratif elementler */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-20 left-10 w-32 h-32 bg-primary-100 rounded-full opacity-20 animate-pulse-slow"></div>
                    <div className="absolute bottom-40 right-10 w-28 h-28 bg-primary-200 rounded-full opacity-15 animate-float"></div>
                    <div className="absolute top-1/2 left-1/4 w-20 h-20 bg-primary-300 rounded-full opacity-10 animate-bounce-slow"></div>
                </div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                    {/* Başlık bölümü */}
                    <div className="text-center mb-16 animate-fade-in">
                        <div className="inline-block bg-gradient-to-r from-primary-100 to-primary-200 text-primary-800 px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-lg">
                            🚀 Süreç
                        </div>
                        <h2 className="text-4xl lg:text-5xl font-bold text-dark-900 mb-6 animate-slide-up">
                            Nasıl Çalışır?
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800 block pt-2 pb-4 mb-2 leading-relaxed">
                                3 Adımda Dijital Davetiye
                            </span>
                        </h2>
                        <p className="text-lg text-dark-600 max-w-3xl mx-auto leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
                            Hayalinizdeki davetiyeyi 3 basit adımda hayata geçiriyoruz. Tasarım seçiminden teslimat sürecine kadar her aşamada sizinle birlikte çalışıyoruz.
                        </p>
                    </div>

                    {/* Adımlar */}
                    <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
                        {/* Adım 1 */}
                        <div className="relative animate-slide-up" style={{ animationDelay: '0.3s' }}>
                            <div className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-primary-200 transform hover:-translate-y-3 relative overflow-hidden">
                                {/* Adım numarası */}
                                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                                    <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 text-white rounded-full flex items-center justify-center shadow-lg relative">
                                        <span className="font-bold text-lg absolute -bottom-0">1</span>
                                    </div>
                                </div>



                                {/* İkon */}
                                <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-600 text-white rounded-3xl mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110 mx-auto mt-4">
                                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                    </svg>
                                </div>

                                {/* Başlık */}
                                <h3 className="text-xl font-bold text-dark-900 mb-4 group-hover:text-primary-700 transition-colors text-center">
                                    Tasarım Seçimi
                                </h3>

                                {/* Açıklama */}
                                <p className="text-dark-600 mb-6 leading-relaxed text-center">
                                    Çalışmalarımız sayfasından size en uygun tasarımı seçin veya özel tasarım taleplerinizi belirtin.
                                </p>

                                {/* Özellikler */}
                                <div className="space-y-3">
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Geniş tasarım koleksiyonu</span>
                                    </div>
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Özel tasarım seçenekleri</span>
                                    </div>
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Anında önizleme</span>
                                    </div>
                                </div>

                                {/* Arka plan dekor */}
                                <div className="absolute -bottom-10 -right-10 w-20 h-20 bg-primary-100 rounded-full opacity-20 group-hover:opacity-30 transition-opacity"></div>
                            </div>

                            {/* Bağlayıcı ok - sadece desktop */}
                            <div className="hidden md:block absolute -right-6 top-1/2 transform -translate-y-1/2 z-10">
                                <div className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center border-2 border-primary-200">
                                    <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        {/* Adım 2 */}
                        <div className="relative animate-slide-up" style={{ animationDelay: '0.5s' }}>
                            <div className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-primary-200 transform hover:-translate-y-3 relative overflow-hidden">
                                {/* Adım numarası */}
                                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                                    <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-primary-600 text-white rounded-full flex items-center justify-center shadow-lg relative">
                                        <span className="font-bold text-lg absolute -bottom-0">2</span>
                                    </div>
                                </div>



                                {/* İkon */}
                                <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-primary-500 to-primary-600 text-white rounded-3xl mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110 mx-auto mt-4">
                                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                    </svg>
                                </div>

                                {/* Başlık */}
                                <h3 className="text-xl font-bold text-dark-900 mb-4 group-hover:text-primary-700 transition-colors text-center">
                                    Bilgi Paylaşımı & Revizyon
                                </h3>

                                {/* Açıklama */}
                                <p className="text-dark-600 mb-6 leading-relaxed text-center">
                                    Etkinlik bilgilerinizi bizimle paylaşın. Uzman ekibimiz tasarımı size özel olarak revize eder.
                                </p>

                                {/* Özellikler */}
                                <div className="space-y-3">
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Kişisel bilgiler ekleme</span>
                                    </div>
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Profesyonel tasarım revizyonu</span>
                                    </div>
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Sınırsız düzeltme hakkı</span>
                                    </div>
                                </div>

                                {/* Arka plan dekor */}
                                <div className="absolute -bottom-10 -right-10 w-20 h-20 bg-primary-100 rounded-full opacity-20 group-hover:opacity-30 transition-opacity"></div>
                            </div>

                            {/* Bağlayıcı ok - sadece desktop */}
                            <div className="hidden md:block absolute -right-6 top-1/2 transform -translate-y-1/2 z-10">
                                <div className="w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center border-2 border-primary-200">
                                    <svg className="w-6 h-6 text-primary-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                        {/* Adım 3 */}
                        <div className="relative animate-slide-up" style={{ animationDelay: '0.7s' }}>
                            <div className="group bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-primary-200 transform hover:-translate-y-3 relative overflow-hidden">
                                {/* Adım numarası */}
                                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                                    <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-emerald-600 text-white rounded-full flex items-center justify-center shadow-lg relative">
                                        <span className="font-bold text-lg absolute -bottom-0">3</span>
                                    </div>
                                </div>



                                {/* İkon */}
                                <div className="flex items-center justify-center w-20 h-20 bg-gradient-to-br from-emerald-500 to-emerald-600 text-white rounded-3xl mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110 mx-auto mt-4">
                                    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
                                    </svg>
                                </div>

                                {/* Başlık */}
                                <h3 className="text-xl font-bold text-dark-900 mb-4 group-hover:text-emerald-700 transition-colors text-center">
                                    Teslimat & Kullanım
                                </h3>

                                {/* Açıklama */}
                                <p className="text-dark-600 mb-6 leading-relaxed text-center">
                                    Hazır olan davetiyeniz size teslim edilir. Artık misafirlerinizle paylaşmaya başlayabilirsiniz!
                                </p>

                                {/* Özellikler */}
                                <div className="space-y-3">
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Anında kullanıma hazır</span>
                                    </div>
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">Çoklu paylaşım seçenekleri</span>
                                    </div>
                                    <div className="flex items-center justify-center space-x-3">
                                        <div className="w-2 h-2 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-full"></div>
                                        <span className="text-sm text-dark-600 font-medium">24/7 teknik destek</span>
                                    </div>
                                </div>

                                {/* Arka plan dekor */}
                                <div className="absolute -bottom-10 -right-10 w-20 h-20 bg-emerald-100 rounded-full opacity-20 group-hover:opacity-30 transition-opacity"></div>
                            </div>
                        </div>
                    </div>

                    {/* Alt bilgi kutusu */}
                    <div className="text-center mt-16 animate-slide-up" style={{ animationDelay: '0.9s' }}>
                        <div className="bg-gradient-to-r from-primary-600 to-primary-700 rounded-3xl p-8 lg:p-12 shadow-2xl text-white relative overflow-hidden">
                            {/* Arka plan pattern */}
                            <div className="absolute inset-0 opacity-10">
                                <div className="absolute top-0 right-0 w-32 h-32 bg-white rounded-full -translate-y-8 translate-x-8"></div>
                                <div className="absolute bottom-0 left-0 w-24 h-24 bg-white rounded-full translate-y-6 -translate-x-6"></div>
                            </div>

                            <div className="relative">
                                <h3 className="text-2xl lg:text-3xl font-bold mb-4">
                                    🎉 Hayalinizdi Gerçek Olsun!
                                </h3>
                                <p className="text-primary-100 mb-8 max-w-2xl mx-auto">
                                    Tüm süreç en kısa sürede tamamlanır. Unutulmaz anılarınız için hemen başlayalım!
                                </p>
                                <button
                                    onClick={() => {
                                        const element = document.getElementById('iletisim');
                                        if (element) {
                                            element.scrollIntoView({ behavior: 'smooth' });
                                        }
                                    }}
                                    className="border-2 border-white text-white px-8 py-4 rounded-xl hover:bg-white hover:text-primary-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1">
                                    Hemen Başlayalım 🚀
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section id="neden-biz" className="relative py-20 lg:py-28 bg-gradient-to-b from-primary-50 via-white to-dark-50 overflow-hidden">
                {/* Arka plan dekoratif elementler */}
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute top-40 right-5 w-44 h-44 bg-primary-200 rounded-full opacity-10 animate-float"></div>
                    <div className="absolute bottom-32 left-8 w-36 h-36 bg-dark-200 rounded-full opacity-15 animate-pulse-slow"></div>
                    <div className="absolute top-1/4 left-1/2 w-24 h-24 bg-primary-100 rounded-full opacity-20 animate-bounce-slow"></div>
                </div>

                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                    {/* Başlık bölümü */}
                    <div className="text-center mb-20 animate-fade-in">
                        <div className="inline-block bg-gradient-to-r from-primary-100 to-primary-200 text-primary-800 px-6 py-3 rounded-full text-sm font-semibold mb-6 shadow-lg">
                            ⭐ Neden Biz?
                        </div>
                        <h2 className="text-4xl lg:text-5xl font-bold text-dark-900 mb-10 animate-slide-up">
                            Dijital Davetiye ile
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800 block pb-2 mb-2">
                                Geleceğe Adım Atın
                            </span>
                        </h2>
                        <p className="text-lg text-dark-600 max-w-3xl mx-auto leading-relaxed animate-slide-up" style={{ animationDelay: '0.2s' }}>
                            Geleneksel davetiyelerin tüm sınırlarını aşan, modern teknoloji ile desteklenen
                            dijital davetiyelerle misafirlerinize unutulmaz bir deneyim sunun.
                        </p>
                    </div>

                    {/* Özellik Kartları */}
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20 animate-slide-up" style={{ animationDelay: '0.4s' }}>
                        {/* Mutlu Müşteriler */}
                        <div className="group bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="text-center">
                                {/* Icon Container */}
                                <div className="flex justify-center mb-4">
                                    <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-pink-600 rounded-lg flex items-center justify-center shadow-md">
                                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* Content */}
                                <h3 className="text-lg font-bold text-gray-800 mb-2">
                                    Mutlu Müşterilere
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Siz de <span className="text-red-500 font-semibold">Katılın!</span> 🎉
                                </p>
                            </div>
                        </div>

                        {/* Anında Ulaşım */}
                        <div className="group bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="text-center">
                                {/* Icon Container */}
                                <div className="flex justify-center mb-4">
                                    <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-lg flex items-center justify-center shadow-md">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M13 10V3L4 14h7v7l9-11h-7z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* Content */}
                                <h3 className="text-lg font-bold text-gray-800 mb-2">
                                    Anında Ulaşım
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Hızını <span className="text-emerald-500 font-semibold">Deneyimle!</span> ⚡
                                </p>
                            </div>
                        </div>

                        {/* Mükemmel Kalite */}
                        <div className="group bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="text-center">
                                {/* Icon Container */}
                                <div className="flex justify-center mb-4">
                                    <div className="w-16 h-16 bg-gradient-to-br from-pink-500 to-rose-600 rounded-lg flex items-center justify-center shadow-md">
                                        <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* Content */}
                                <h3 className="text-lg font-bold text-gray-800 mb-2">
                                    Mükemmel Kalite
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Memnuniyet <span className="text-pink-500 font-semibold">Yaşayın!</span> ⭐
                                </p>
                            </div>
                        </div>

                        {/* Doğayı Koruyun */}
                        <div className="group bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300 transform hover:-translate-y-2 border border-gray-100">
                            <div className="text-center">
                                {/* Icon Container */}
                                <div className="flex justify-center mb-4">
                                    <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-emerald-600 rounded-lg flex items-center justify-center shadow-md">
                                        <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </svg>
                                    </div>
                                </div>

                                {/* Content */}
                                <h3 className="text-lg font-bold text-gray-800 mb-2">
                                    Doğayı Koruyun
                                </h3>
                                <p className="text-sm text-gray-600">
                                    Ağaçları <span className="text-green-500 font-semibold">Kurtarın!</span> 🌱
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Avantajlar Slider */}
                    <div className="mb-20 animate-slide-up" style={{ animationDelay: '0.6s' }}>
                        {/* Slider Başlığı */}
                        <div className="text-center mb-8">
                            <div className="inline-block bg-gradient-to-r from-primary-100 to-emerald-100 text-primary-800 px-6 py-2 rounded-full text-sm font-semibold mb-4 shadow-lg">
                                🚀 Avantajlarımız
                            </div>
                            <h3 className="text-4xl lg:text-5xl font-bold text-dark-900 mb-6 animate-slide-up">
                                Dijital Davetiyenin
                                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 to-primary-800 block pt-2 pb-1 mb-1 leading-relaxed">
                                    Avantajları
                                </span>
                            </h3>
                            <p className="text-lg text-dark-600 max-w-2xl mx-auto">
                                Geleneksel davetiyelerden çok daha fazlasını sunuyoruz
                            </p>
                        </div>

                        {/* Slider Container - Desktop için 2 kart, mobil için 1 kart */}
                        <div className="hidden md:block mt-2 mb-6">
                            {/* Navigation Arrows - Sliderın dışına taşındı */}
                            <div className="flex justify-end space-x-2 mb-4">
                                <button
                                    onClick={() => setCurrentSlide(currentSlide > 0 ? currentSlide - 1 : Math.ceil(advantages.length / 2) - 1)}
                                    className="w-10 h-10 bg-white rounded-full shadow-md hover:shadow-lg flex items-center justify-center text-primary-600 hover:text-primary-700 transition-all duration-300 hover:scale-105 border border-gray-100 focus:outline-none"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>

                                <button
                                    onClick={() => setCurrentSlide(currentSlide < Math.ceil(advantages.length / 2) - 1 ? currentSlide + 1 : 0)}
                                    className="w-10 h-10 bg-white rounded-full shadow-md hover:shadow-lg flex items-center justify-center text-primary-600 hover:text-primary-700 transition-all duration-300 hover:scale-105 border border-gray-100 focus:outline-none"
                                >
                                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>
                            </div>

                            {/* Slider Wrapper */}
                            <div className="relative overflow-hidden rounded-2xl mt-6 mb-8" style={{ height: "270px" }}>
                                <div
                                    className="flex transition-transform duration-500 ease-in-out h-full"
                                    style={{
                                        transform: `translateX(-${currentSlide * 50}%)`,
                                    }}
                                >
                                    {advantages.map((advantage, index) => (
                                        <div
                                            key={index}
                                            className="w-1/2 px-3 py-3 flex-shrink-0"
                                        >
                                            {/* Kart Tasarımı */}
                                            <div className="group bg-gradient-to-br from-white via-white to-primary-25 rounded-xl p-4 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-primary-200 transform hover:-translate-y-2 mx-1 relative overflow-hidden h-full">
                                                {/* Arka plan dekoratif elementler */}
                                                <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-primary-100 to-transparent rounded-full opacity-20 blur-lg"></div>
                                                <div className="absolute bottom-0 left-0 w-6 h-6 bg-gradient-to-tr from-emerald-100 to-transparent rounded-full opacity-15 blur-md"></div>

                                                {/* İçerik */}
                                                <div className="relative">
                                                    {/* Üst bölüm - İkon ve Badge */}
                                                    <div className="flex items-start justify-between mb-3">
                                                        <div className="inline-flex items-center justify-center w-11 h-11 bg-gradient-to-br from-primary-500 via-primary-600 to-primary-700 text-white rounded-xl shadow-md group-hover:shadow-lg transition-all duration-300 group-hover:scale-105">
                                                            <div className="w-6 h-6 flex items-center justify-center">
                                                                {advantage.icon}
                                                            </div>
                                                        </div>
                                                        <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 text-emerald-700 px-2 py-1 rounded-full text-xs font-bold shadow-sm">
                                                            {advantage.benefit}
                                                        </div>
                                                    </div>

                                                    {/* Başlık */}
                                                    <h3 className="text-lg font-bold text-dark-900 mb-2 group-hover:text-primary-700 transition-colors leading-tight">
                                                        {advantage.title}
                                                    </h3>

                                                    {/* Açıklama */}
                                                    <p className="text-dark-600 leading-relaxed text-sm mb-3">
                                                        {advantage.description}
                                                    </p>

                                                    {/* Alt çizgi efekti */}
                                                    <div className="w-8 h-0.5 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full group-hover:w-12 transition-all duration-300"></div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Dot Indicators - Sadece desktop slider için */}
                        <div className="hidden md:flex justify-center space-x-3 mt-4">
                            {Array.from({ length: Math.ceil(advantages.length / 2) }).map((_, index) => (
                                <button
                                    key={index}
                                    onClick={() => setCurrentSlide(index)}
                                    className={`h-2 rounded-full transition-all duration-300 ${currentSlide === index
                                        ? 'bg-primary-600 w-6'
                                        : 'bg-gray-300 hover:bg-primary-300 w-2'
                                        }`}
                                    aria-label={`Slide ${index + 1}`}
                                />
                            ))}
                        </div>

                        {/* Mobil için kartlar görünümü */}
                        <div className="block md:hidden mt-12">
                            <div className="grid gap-6">
                                {advantages.map((advantage, index) => (
                                    <div
                                        key={index}
                                        className="group bg-gradient-to-br from-white via-white to-primary-25 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
                                    >
                                        {/* Mobil kart içeriği */}
                                        <div className="flex items-start space-x-4 mb-4">
                                            <div className="inline-flex items-center justify-center w-14 h-14 bg-gradient-to-br from-primary-500 to-primary-600 text-white rounded-2xl shadow-lg">
                                                {advantage.icon}
                                            </div>
                                            <div className="flex-1">
                                                <h3 className="text-lg font-bold text-dark-900 mb-2">
                                                    {advantage.title}
                                                </h3>
                                                <div className="bg-gradient-to-r from-emerald-50 to-emerald-100 text-emerald-700 px-3 py-1 rounded-full text-xs font-bold inline-block">
                                                    {advantage.benefit}
                                                </div>
                                            </div>
                                        </div>
                                        <p className="text-dark-600 leading-relaxed">
                                            {advantage.description}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* Karşılaştırma Tablosu */}
                    <div className="mb-20 animate-slide-up" style={{ animationDelay: '0.8s' }}>
                        {/* Dramatik Başlık */}
                        <div className="text-center mb-16 relative">
                            {/* Arka plan efekti */}
                            <div className="absolute inset-0 flex justify-center items-center">
                                <div className="w-96 h-32 bg-gradient-to-r from-primary-100 via-primary-200 to-primary-100 rounded-full opacity-20 blur-3xl"></div>
                            </div>

                            <div className="relative">
                                {/* Üst badge */}
                                <div className="inline-flex items-center justify-center mb-8">
                                    <div className="bg-gradient-to-r from-gray-100 to-primary-100 px-6 py-3 rounded-full shadow-lg">
                                        <div className="flex items-center space-x-4">
                                            <div className="flex items-center space-x-2">
                                                <div className="w-6 h-6 bg-gray-400 rounded-full"></div>
                                                <span className="text-dark-600 font-medium">Geleneksel</span>
                                            </div>
                                            <span className="text-2xl font-bold text-dark-500">⚡</span>
                                            <div className="flex items-center space-x-2">
                                                <div className="w-6 h-6 bg-gradient-to-r from-primary-500 to-primary-600 rounded-full"></div>
                                                <span className="text-primary-700 font-bold">Dijital</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Ana başlık */}
                                <h3 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight">
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-gray-700 via-gray-800 to-gray-900 block">
                                        Geleneksel
                                    </span>
                                    <div className="flex items-center justify-center my-4">
                                        <div className="flex-1 h-1 bg-gradient-to-r from-transparent to-gray-300"></div>
                                        <span className="mx-6 text-3xl lg:text-4xl text-primary-500 font-black">VS</span>
                                        <div className="flex-1 h-1 bg-gradient-to-l from-transparent to-primary-300"></div>
                                    </div>
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary-600 via-primary-700 to-primary-800 block pb-4 mb-2 leading-relaxed">
                                        Dijital Davetiye
                                    </span>
                                </h3>

                                {/* Alt açıklama */}
                                <p className="text-xl text-dark-600 max-w-3xl mx-auto mb-8 font-medium">
                                    Hangi yöntemin size daha uygun olduğunu keşfedin ve geleceğin davetiye deneyimini yaşayın
                                </p>

                                {/* Dekoratif elementler */}
                                <div className="flex justify-center space-x-4 mb-8">
                                    <div className="w-3 h-3 bg-gray-400 rounded-full animate-pulse"></div>
                                    <div className="w-3 h-3 bg-primary-500 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
                                    <div className="w-3 h-3 bg-primary-600 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100">
                            <div className="overflow-x-auto">
                                <table className="w-full">
                                    <thead>
                                        <tr className="bg-gradient-to-r from-dark-50 to-primary-50">
                                            <th className="py-6 px-6 text-left text-dark-900 font-bold text-lg">Özellik</th>
                                            <th className="py-6 px-6 text-center text-dark-600 font-semibold">Geleneksel</th>
                                            <th className="py-6 px-6 text-center text-primary-700 font-bold">DijiVite ✨</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {comparisons.map((comparison, index) => (
                                            <tr key={index} className="border-t border-gray-100 hover:bg-primary-25 transition-colors">
                                                <td className="py-6 px-6 font-semibold text-dark-900">{comparison.feature}</td>
                                                <td className="py-6 px-6 text-center text-dark-600">{comparison.traditional}</td>
                                                <td className="py-6 px-6 text-center">
                                                    <span className="text-primary-700 font-bold">{comparison.digital}</span>
                                                    <span className="ml-2 text-emerald-500">✓</span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    {/* Alt CTA bölümü */}
                    <div className="text-center animate-slide-up" style={{ animationDelay: '1s' }}>
                        <div className="bg-gradient-to-r from-dark-900 via-dark-800 to-dark-900 rounded-3xl p-8 lg:p-12 shadow-2xl text-white relative overflow-hidden">
                            {/* Arka plan pattern */}
                            <div className="absolute inset-0 opacity-10">
                                <div className="absolute top-0 right-0 w-48 h-48 bg-primary-500 rounded-full blur-3xl animate-pulse-slow"></div>
                                <div className="absolute bottom-0 left-0 w-40 h-40 bg-emerald-500 rounded-full blur-2xl animate-float"></div>
                                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-32 h-32 bg-white rounded-full blur-xl animate-bounce-slow"></div>
                            </div>

                            <div className="relative">
                                <h3 className="text-3xl lg:text-4xl font-bold mb-6">
                                    Hala Düşünüyor musunuz?
                                </h3>
                                <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
                                    Dijital davetiye ile geleneksel davetiyenin tüm sınırlarını aşın.
                                    Misafirlerinize modern ve unutulmaz bir deneyim sunun.
                                </p>
                                <div className="flex flex-col sm:flex-row gap-6 justify-center">
                                    <button
                                        onClick={() => {
                                            const contactElement = document.getElementById('iletisim');
                                            if (contactElement) {
                                                contactElement.scrollIntoView({
                                                    behavior: 'smooth',
                                                    block: 'start'
                                                });
                                            }
                                        }}
                                        className="border-2 border-white text-white px-10 py-4 rounded-xl hover:bg-white hover:text-dark-900 transition-all duration-300 font-bold text-lg"
                                    >
                                        İletişime Geç
                                    </button>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default WhyUs; 